import React from 'react';

type dockDoorProp = {
	door: number;
};

export default function DockDoorNumber({ door }: dockDoorProp) {
	return (
		(door<10)? 
		<div className="flex ml-1 items-start justify-between" style={{ width : "1.5rem",  borderInlineWidth: "5px" , borderColor :"rgba(240, 245, 240, var(--tw-border-opacity))"}}>
			<div className="text-sm font-bold">{door}</div>
		</div> : (door<100)?  <div className="flex ml-1  justify-center" style={{ width : "1.5rem" }}>
			<div className="text-sm font-bold">{door}</div>  
		</div>: <div className="flex ml-1 items-start justify-between" style={{ width : "1.5rem" }}>
			<div className="text-sm font-bold">{door}</div> 
		</div>
	);
}
